import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateGoogleConfigComponent } from "../create-google-config/create-google-config.component";
import { MenuItem } from 'primeng/api';
import { GoogleConfigService } from 'src/app/private/services/googleConfig.service';
import { CenterService } from 'src/app/private/services/center.service';
import { DeleteGoogleConfigComponent } from "../delete-google-config/delete-google-config.component";

@Component({
  selector: 'app-google-config-details',
  imports: [SharedModule, CreateGoogleConfigComponent, DeleteGoogleConfigComponent],
  templateUrl: './google-config-details.component.html',
  styleUrl: './google-config-details.component.scss'
})
export class GoogleConfigDetailsComponent {
  @Input() clientId!: string;
  googleConfigs: any[] = [];
  totalRecords = 0;
  rows = 10;
  loading = true;

  displayAddModal = false;
  showEditConfig = false;
  showDeleteConfig = false;
  configDataToEdit: any = null;
  centers: any[] = [];

  configActionItem: MenuItem[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Config',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.showEditConfig = true;
          },
        },
        {
          label: 'Delete Config',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteConfig = true;
          },
        },
      ],
    },
  ];

  constructor(
    private googleConfigService: GoogleConfigService,
    private centerService: CenterService
  ) { }

  ngOnInit(): void {
    this.loadCenters({ first: 0, rows: this.rows });
  }

  openAddModal() {
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
  }

  setConfigData(data: any) {
    this.configDataToEdit = data;
  }

  loadConfigs(event: any): void {
    this.loading = true;

    const payload = {
      client_id: this.clientId
    };

    this.googleConfigService.getAllGoogleTokenConfigByClientId(payload).subscribe({
      next: (data : any) => {
        this.googleConfigs = data ? [data] : [];
        this.totalRecords = this.googleConfigs.length;
        this.loading = false;
      },
      error: (err) => {
        this.googleConfigs = [];
        this.totalRecords = 0;
        console.error('Error loading configs:', err);
        this.loading = false;
      },
    });
  }

  reload() {
    this.loadConfigs({ first: 0, rows: this.rows });
  }

  loadCenters(event: any): void {
    this.loading = true;
    const payload = {
      page: 0,
      limit: 100,
      where: {
        client_id: this.clientId,
      },
      order: {
        col: '"center"."updatedAt"',
        dir: 'DESC',
      },
    };

    this.centerService.getAllCenterWithCount(payload).subscribe({
      next: (data) => {
        this.centers = data?.rows || [];
        this.totalRecords = data?.count || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading centers:', err);
        this.loading = false;
      }
    });
  }
}
